<script setup lang="ts">
const menuItems = computed<Array<MenuItem>>(() => [{
  title: 'Kontakt',
  path: '/contact',
  show: true
}]);
const open = ref<boolean>(false);
const openList = ref<Object>({});
</script>

<template>
  <header>
    <nav class="navbar">
      <div id="logo">
        <NuxtLink href="/" class="scale-100 hover:scale-[1.05] ease-in duration-200">
          <svg :class="[
              'block',
              useNuxtApp()?.$styleSize?.value ? ('rounded-' + useNuxtApp()?.$styleSize?.value) : 'rounded',
            ]"
            xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
            width="170" height="45"
            viewBox="0 0 212.72 59.46"
            aria-hidden="true" role="img" >
            <path class="fill-primary"
              d="m133.83,30.2l-1.76-4.82h-9.5l-1.88,4.82h-3.9l10.37-23.16h.92l9.62,23.16h-3.87Zm-6.38-17.17l-3.96,10.06h7.58l-3.63-10.06Zm19.38-2.87v20.04h-3.44V10.16h-8.01v-2.81h19.83v2.81h-8.37Zm21.15,20.04l-1.74-4.82h-9.37l-1.86,4.82h-3.85l10.23-23.16h.91l9.49,23.16h-3.82Zm-6.29-17.17l-3.9,10.06h7.48l-3.58-10.06Zm29.05,17.48l-13.02-16.7v16.39h-3.27V7.35h1.38l12.67,15.8V7.35h3.27v23.16h-1.03Zm-73.88,24.69v-22.85h3.12v22.85h-3.12Zm23.11.31l-11.81-16.7v16.39h-2.96v-22.85h1.25l11.49,15.8v-15.8h2.96v23.16h-.94Zm13.57,0h-1.58l-8.51-23.16h3.46l5.88,16.83,5.66-16.83h3.35l-8.26,23.16Zm13.93-20.35v6.35h7.55v2.65h-7.55v8.23h10.35v2.81h-13.47v-22.85h13.64v2.81h-10.53Zm12.96,18.99l1.14-2.87c.58.43,1.31.78,2.18,1.07.87.29,1.64.43,2.33.43,1.22,0,2.19-.33,2.93-1,.74-.67,1.11-1.51,1.11-2.54,0-.77-.21-1.48-.62-2.14s-1.44-1.38-3.1-2.16l-1.84-.86c-1.56-.73-2.65-1.59-3.27-2.59-.62-1-.93-2.2-.93-3.6,0-1.7.6-3.12,1.81-4.24,1.21-1.12,2.75-1.68,4.65-1.68,2.53,0,4.28.41,5.27,1.23l-.92,2.71c-.42-.3-1.05-.59-1.9-.87s-1.64-.42-2.37-.42c-1.06,0-1.89.3-2.5.9-.61.6-.91,1.38-.91,2.32,0,.58.11,1.11.33,1.59s.52.88.91,1.2,1.19.78,2.39,1.36l1.87.89c1.56.74,2.65,1.62,3.28,2.64.63,1.02.94,2.33.94,3.91,0,1.71-.69,3.17-2.07,4.37-1.38,1.2-3.22,1.79-5.53,1.79-2.03,0-3.76-.48-5.19-1.43Zm24.72-18.99v20.04h-3.12v-20.04h-7.27v-2.81h17.98v2.81h-7.59ZM78.04,7.27c0-2.37-1.92-4.29-4.29-4.29s-4.29,1.92-4.29,4.29,1.92,4.29,4.29,4.29,4.29-1.92,4.29-4.29Zm-2.23,9.73h-4.11v42.47h4.11V16.99ZM40.46,2.98l-17.27,42.44h4.11s13.16-32.34,13.16-32.34h0s18.91,46.38,18.91,46.38h4.11L40.46,2.98Zm-14.94,52.2c0-2.37-1.92-4.29-4.29-4.29s-4.29,1.92-4.29,4.29,1.92,4.29,4.29,4.29,4.29-1.92,4.29-4.29Zm80.17-20.8l2.58-3.08h-.01s0-.02,0-.02l-2.58-3.08h0s-18.63-22.2-18.63-22.2l-3.03,2.54,19.08,22.74-19.04,22.28,3.03,2.54,18.59-21.74h.01Zm-103.1.05l11.33,14.52,3.03-2.55-11.77-15.06L24.24,8.54l-3.03-2.55L2.59,28.26h0S0,31.33,0,31.33h0s-.01.02-.01.02l2.58,3.08h.01ZM103.52,0c.12.01.23.03.35.04.7.06,1.36.24,2.01.5.74.3,1.41.72,2.01,1.25.91.81,1.55,1.8,1.95,2.94.18.52.3,1.06.36,1.62.14,1.44-.15,2.79-.84,4.06-.76,1.39-1.87,2.39-3.31,3.04-.61.27-1.25.46-1.92.55-.59.08-1.19.08-1.78,0-1.03-.13-1.98-.47-2.87-1.01-1.03-.63-1.84-1.48-2.43-2.54-.39-.7-.66-1.45-.8-2.24-.09-.53-.12-1.06-.09-1.6.04-.71.19-1.39.44-2.05.39-1.03.98-1.93,1.79-2.69.97-.9,2.11-1.47,3.39-1.74.32-.07.64-.09.96-.13.04,0,.07-.01.11-.02C103.07,0,103.3,0,103.52,0Zm-5.95,7.05c.05,3.15,2.55,5.65,5.73,5.58,3.07-.06,5.53-2.52,5.48-5.69-.05-3.09-2.53-5.55-5.7-5.51-3.11.05-5.49,2.52-5.52,5.61Zm2.53-3.85s.07,0,.11,0c1.07,0,2.14,0,3.21.01.52,0,1.03.1,1.5.34.45.23.72.6.83,1.09.09.42.09.85-.03,1.26-.16.54-.54.88-1.04,1.1-.04.02-.08.03-.13.05-.04.02-.08.03-.11.04.15.09.32.16.47.27.29.21.49.51.66.82.39.77.77,1.55,1.16,2.32,0,0,0,.02.01.04-.11,0-.2,0-.3,0-.54,0-1.09,0-1.63,0-.07,0-.09-.03-.12-.08-.32-.65-.64-1.31-.97-1.96-.07-.15-.18-.28-.28-.4-.19-.22-.44-.31-.72-.33-.23-.01-.46,0-.7,0v2.77h-1.9V3.19Zm1.89,3.26c.08,0,.15,0,.22,0,.32,0,.64,0,.96-.03.38-.03.62-.25.7-.61.03-.12.03-.25.03-.38,0-.5-.29-.82-.8-.84-.36-.02-.72-.02-1.07-.02-.01,0-.02,0-.04,0v1.88Z" />
            <!-- ART AUTHOR: fadrulinik@gmail.com -->
          </svg>
        </NuxtLink>
        <button class="block sm:hidden" @click="open = !open">
          <svg
            class="fill-primary w-4 h-4 scale-100 hover:scale-125 ease-in duration-200"
            xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 20 20"
            aria-hidden="true" role="img">
            <title>Menu</title>
            <path v-show="open"
              d="M18.278 16.864a1 1 0 01-1.414 1.414l-4.829-4.828-4.828 4.828a1 1 0 01-1.414-1.414l4.828-4.829-4.828-4.828a1 1 0 011.414-1.414l4.829 4.828 4.828-4.828a1 1 0 111.414 1.414l-4.828 4.829 4.828 4.828z" />
            <path v-show="!open"
              d="M4 5h16a1 1 0 010 2H4a1 1 0 110-2zm0 6h16a1 1 0 010 2H4a1 1 0 010-2zm0 6h16a1 1 0 010 2H4a1 1 0 010-2z" />
          </svg>
        </button>
      </div>
      <ol id="menu" :class="[(open && 'opened'), ('list-image-none')]">
        <div v-for="item of menuItems.filter((item: MenuItem) => item.show)" :key="item.path">
          <li>
            <BaseLink :href="item.path" @click="item.click"
              :size="(['xl', '2xl'].includes(useNuxtApp()?.$styleSize?.value) ? useNuxtApp()?.$styleSize?.value : 'lg')"
              :disabled="item.disabled" :class-name="[
                'font-medium hover:text-slate-900',
                (!item.disabled && 'scale-100 hover:scale-[1.05] ease-in duration-200')
              ]">
              {{ item.title }}
            </BaseLink>
            <button v-if="item.items?.filter((subItem: MenuBase) => subItem.show)" class="text-slate-800"
              @click="openList[item.title] = !openList[item.title]">
              <svg class="fill-primary w-4 h-4 scale-100 hover:scale-125 ease-in duration-200"
                xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                viewBox="0 0 20 20"
                aria-hidden="true" role="img">
                <title>{{ item.title }}</title>
                <path v-show="openList[item.title]"
                  d="M18.278 16.864a1 1 0 01-1.414 1.414l-4.829-4.828-4.828 4.828a1 1 0 01-1.414-1.414l4.828-4.829-4.828-4.828a1 1 0 011.414-1.414l4.829 4.828 4.828-4.828a1 1 0 111.414 1.414l-4.828 4.829 4.828 4.828z" />
                <path v-show="!openList[item.title]"
                  d="M4 5h16a1 1 0 010 2H4a1 1 0 110-2zm0 6h16a1 1 0 010 2H4a1 1 0 010-2zm0 6h16a1 1 0 010 2H4a1 1 0 010-2z" />
              </svg>
            </button>
          </li>
          <BaseCollapse v-if="item.items?.filter((subItem: MenuBase) => subItem.show)" v-model="openList[item.title]"
            class="open:animate-[down-fade-in_400ms_ease-in-out]">
            <li v-for="subItem of item.items?.filter((subItem: MenuBase) => subItem.show)" :key="subItem.path">
              <BaseLink :href="subItem.path" @click="subItem.click"
                :size="(['xl', '2xl'].includes(useNuxtApp()?.$styleSize?.value) ? useNuxtApp()?.$styleSize?.value : 'lg')"
                :class-name="[
                  'font-normal hover:text-slate-900',
                  (!subItem.disabled && 'scale-100 hover:scale-[1.05] ease-in duration-200')
                ]" :disabled="subItem.disabled">
                {{ subItem.title }}
              </BaseLink>
            </li>
          </BaseCollapse>
        </div>
      </ol>
    </nav>
  </header>
</template>

<style lang="scss" scoped>
.navbar {
  @apply m-1 flex flex-col;
  @apply sm:flex-row sm:justify-between sm:items-center;

  >#logo {
    @apply flex flex-row justify-between items-center;
  }

  >#menu {
    @apply flex flex-col overflow-hidden;
    @apply sm:flex-row sm:gap-5 sm:overflow-visible;

    @apply max-h-0 transition-[max-height] duration-1000;
    @apply sm:max-h-screen sm:transition-none sm:duration-0;

    &.opened {
      @apply max-h-screen transition-[max-height] duration-[2000ms] ease-in-out;

      /* Desktop */
      /* max-height: 100vh;
          transition: max-height 2s ease-in-out; */
    }

    >div {
      @apply border-b sm:border-0;

      &:last-child {
        @apply border-0;

        li {
          &:last-child {
            @apply mb-0;
          }
        }
      }

      li {
        @apply flex justify-between gap-2 my-1 sm:my-0;

        a,
        button {
          @apply p-0 px-1;
        }
      }

      &:last-child>li {
        @apply mb-0;
      }
    }
  }
}
</style>
